import { createContext, useReducer, useEffect, useMemo } from "react";

export const AuthContext = createContext();

export function authReducer(state, action) {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        admin: action.payload,
      };
    case "LOGOUT":
      return {
        ...state,
        admin: null,
      };
    default:
      return state;
  }
}

export const AuthContextProvider = ({ children }) => {
  const _admin = useMemo(
    () =>
      sessionStorage.getItem("admin") &&
      JSON.parse(sessionStorage.getItem("admin")),
    []
  );
  const token = useMemo(() => sessionStorage.getItem("access"), []);

  const [state, dispatch] = useReducer(authReducer, {
    admin: _admin,
    token,
  });

  useEffect(() => {
    if (_admin) {
      dispatch({ type: "LOGIN", payload: _admin });
    }
  }, [_admin]);

  // console.log("AuthContextState: ", _admin);

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
